import SVGA from 'svgaplayerweb';
import EXIF from 'exif-js';
import store from '../store';

// 货币类型（完整列表）
const CURRENCY = [
  'CNY', 'JPY', 'HKD', 'USD', 'KRW',
  'TWD', 'AUD', 'GBP', 'IDR', 'NZD',
  'SGD', 'THB', 'SEK', 'CHF', 'RUB',
  'PHP', 'MYR', 'EUR', 'INR', 'DKK',
  'CAD', 'NOK', 'AED', 'SAR', 'BRL',
  'MOP', 'ZAR', 'TRY'
];

export function getLangAndCurrencyFromLocal (){
  let currency = 'CNY';
  let langType = 1;

  if(localStorage.getItem('currency_code') != 'undefined'){
    currency = localStorage.getItem('currency_code');
  }

  if(localStorage.getItem('lan_type') != 'undefined'){
    langType = localStorage.getItem('lan_type');
  }

  return {currency_code: currency, lan_type: langType};
};

/** 从URL获取语言类型和货币 */
export function getLanTypeFromUrl (){
  const url = window.location.href;
  let lan = getQueryString('lan_type', url) || 1;
  let cur = getQueryString('currency_code', url) || 'CNY';

  localStorage.setItem('lan_type', getLangType(lan));
  localStorage.setItem('currency_code', CURRENCY.indexOf(cur) > -1 ? cur : 'CNY');
};

/** 将时间戳转为日期格式 */
export function formatDateWithStamp (stamp, isFull = false, fmt = '-'){
  // console.log(String(stamp).replace(/[-]/g, '/'));
  const fmtStamp = Number.isInteger(+stamp) ? +stamp : stamp.replace(/[-]/g, '/');
  const oDate = new Date(fmtStamp);
  const year = oDate.getFullYear();
  const month = oDate.getMonth() + 1;
  const date = oDate.getDate();
  let result = '';

  if(isFull){
    result = `${year}${fmt}${addZero(month)}${fmt}${addZero(date)}`;
  }else{
    result = `${addZero(month)}${fmt}${addZero(date)}`;
  }

  return result;
};

/** 计算两个日期间的天数 */
export function calcCycle (startDate, endDate){
  const oStartDate = new Date(startDate);
  const oEndDate = new Date(endDate);
  const startTimestamp = Number(new Date(oStartDate.getFullYear(), oStartDate.getMonth(), oStartDate.getDate()).getTime());
  const endTimestamp = Number(new Date(oEndDate.getFullYear(), oEndDate.getMonth(), oEndDate.getDate()).getTime());

  return Math.round((endTimestamp - startTimestamp) / 1000 / 3600 / 24);
};

/** 对象深拷贝 */
export function deepCopy (data) {
  let type = checkType(data),
    result,
    i,
    len;

  if (type === 'array') {
    result = [];

    for (i = 0, len = data.length; i < len; i++) {
      result.push(deepCopy(data[i]));
    }
    return result;
  } else if (type === 'object') {
    result = {};

    for (i in data) {
      result[i] = deepCopy(data[i]);
    }
    return result;
  }else{
    return data;
  }
};

/** 类型检查 */
export function checkType (obj) {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };

  return map[toString.call(obj)];
};


/** 保存语言类型和币种到本地 */
export function saveLangAndCurrency (){
  const currency = localStorage.getItem('currency_code');
  const lan_type = getQueryString('lan_type') || returnType(localStorage.getItem('lan_type'));
  const currency_code = getQueryString('currency_code') || (currency && currency !== 'null' && currency !== 'undefined' ? currency : 'CNY');

  localStorage.setItem('lan_type', getLangType(lan_type));
  localStorage.setItem('currency_code', currency_code);
};

/** 语言类型区分 */
export function getLangType (lanType){
  let type = 1;

  switch (lanType) {
    case 'zh_cn': type = 1; break;
    case 'ja_jp': type = 2; break;
    case 'zh_hk': type = 3; break;
    case 'en_us': type = 4; break;
    case 'ko_kr': type = 5; break;
    case 'th_th': type = 6; break;
    case 'de_de': type = 7; break;
    case 'fr_fr': type = 8; break;
    case 'es_es': type = 9; break;
    case 'sv_se': type = 10; break;
    case 'nl_nl': type = 11; break;
    case 'vi_vn': type = 12; break;
    case 'ms_my': type = 13; break;
    case 'id_id': type = 14; break;
    default: type = 1;
  }

  return type;
};
/** 语言类型区分反 */
export function returnType(langNo){
  let type = 'zh_cn';

  switch (Number(langNo)) {
    case 1: type = 'zh_cn'; break;
    case 2: type = 'ja_jp'; break;
    case 3: type = 'zh_hk'; break;
    case 4: type = 'en_us'; break;
    case 5: type = 'ko_kr'; break;
    case 6: type = 'th_th'; break;
    case 7: type = 'de_de'; break;
    case 8: type = 'fr_fr'; break;
    case 9: type = 'es_es'; break;
    case 10: type = 'sv_se'; break;
    case 11: type = 'nl_nl'; break;
    case 12: type = 'vi_vn'; break;
    case 13: type = 'ms_my'; break;
    case 14: type = 'id_id'; break;
    default: type = 'zh_cn';
  }

  return type;
}

/** 其他第三方支付：支付宝、银联等 */
export function otherPayment (consume) {
  let oBody = document.querySelector('body');
  let oForm = document.createElement('form');

  oForm.setAttribute('method', 'POST');
  oForm.setAttribute('action', consume.action);
  for(let k in consume.params){
    let oInput = document.createElement('input');

    oInput.setAttribute('type', 'hidden');
    oInput.setAttribute('name', k);
    oInput.setAttribute('value', consume.params[k]);
    oForm.appendChild(oInput);
  }

  oBody.appendChild(oForm);
  oForm.submit();
  oBody.removeChild(oForm);
};

/** 获取url里面的参数 */
export function getQueryString (name) {
  const queryArr = window.location.search.slice(1).split('&');
  let target = '';

  queryArr.forEach(function (it) {
    const itArr = it.split('=');

    if(itArr[0] === name){
      if(name === 'currency_code'){
        target = CURRENCY.indexOf(itArr[1]) > -1 ? itArr[1] : 'CNY';
      }else{
        target = itArr[1];
      }
    }
  });
  return target;
}

/** 小于9的数字前面补0 */
export const addZero = function(num) {
  return +num > 9 ? num : `0${num}`;
}

export function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  var flag = true;

  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }

  return flag;
}

export function dateCompare(from, to){
  // 时间戳和日期格式判断
  const fromDate = Number.isInteger(+from) ? +from : from.replace(/[-]/g, '/');
  const toDate = Number.isInteger(+to) ? +to : to.replace(/[-]/g, '/');
  let fromTimes = new Date(fromDate).getTime();
  let toTimes = new Date(toDate).getTime();

  return fromTimes >= toTimes ? formatDateWithStamp(fromTimes + 24*60*60*1000, true) : formatDateWithStamp(toTimes, true);
}

/** 滚动条滚动到顶部 */
export const scroll2Top = function(){
  let timer = setInterval(function(){
    const scrollTop=document.documentElement.scrollTop || document.body.scrollTop;
    const iSpeed = Math.floor(-scrollTop / 6);

    if(scrollTop == 0){
      clearInterval(timer);
    }

    document.documentElement.scrollTop = document.body.scrollTop = scrollTop + iSpeed;
  }, 20);
};

export const transformSVGA = function (playerIdSelector, sourceUrl) {
  var player = new SVGA.Player(playerIdSelector);
  var parser = new SVGA.Parser(playerIdSelector);

  parser.load(sourceUrl, function(videoItem) {
    player.setVideoItem(videoItem);
    player.startAnimation();
  });

  return player;
}

/** 格式化星期增强版 */
export const formatWeekWithFullDate = function(date){
  const lanType = +localStorage.getItem('lan_type');
  let weekIdx = new Date(date).getDay();
  let weekStr = '';

  if(lanType === 1 && checkDateIsToday(date) === 'today'){
    weekStr = '今天';
  }else if(lanType === 1 && checkDateIsToday(date) === 'tomorrow'){
    weekStr = '明天';
  }else{
    weekStr = store.state.weekDay[lanType - 1][weekIdx];
  }

  return weekStr;
};

/** 检测日期是否为当天日期 */
export const checkDateIsToday = function(date){
  let oDate = new Date(date);
  let oCurDate = new Date();

  if(oDate.getFullYear() == oCurDate.getFullYear() && oDate.getMonth() == oCurDate.getMonth() && oDate.getDate() == oCurDate.getDate()){
    return 'today';
  }else if(calcCycle(oCurDate, date) === 1){
    return 'tomorrow';
  }
};

/**
 *
 * @param file
 * @param config
 * config = {accuracy[压缩精度], size[指定压缩的目标大小], success[压缩成功回调函数，返回值为base64地址]}
 */
export const imageCompressAndRotate = function (file, config) {
  const reader = new FileReader(),
    image = new Image();
  // type = null;

  const name = file.name;

  // type = (name.substr(name.lastIndexOf("."))).toLowerCase();
  // if (type !== '.jpg' && type !== '.png' && type !== '.jpeg' && type !== '.gif') {
  //   return false;
  // }

  const fileSize = file.size;

  // 精度小于0.8或大于0.99默认设置为0.95
  if (!config.accuracy || config.accuracy < 0.8 || config.accuracy > 0.99) {
    config.accuracy = 0.95;     // 默认精度0.95
  }

  // 结合文件大小和压缩精度计算目标文件的大小范围
  const resultSize = {
    max: config.size * (2 - config.accuracy) * 1024,
    accurate: config.size * 1024,
    min: config.size * config.accuracy * 1024,
  };

  /**
   * 经过测试发现，blob.size与dataURL.length的比值约等于0.75
   * 这个比值可以同过dataURLtoFile这个方法来测试验证
   * 这里为了提高性能，直接通过这个比值来计算出blob.size
   */
  let proportion = 0.75;      // blob.size与dataURL.length的比值
  let imageQuality = 0.5;     // 压缩图片到起始质量系数

  if (file) {
    let Orientation = null;

    EXIF.getData(file, function() {
      Orientation = EXIF.getTag(this, 'Orientation');
    });

    reader.readAsDataURL(file);
    reader.onload = function (ev) {
      image.src = ev.target.result;
      image.onload = function () {
        let imgWidth = this.width,
          imgHeight = this.height;

        const canvas = document.createElement("canvas"),
          ctx = canvas.getContext('2d');

        canvas.width = imgWidth;
        canvas.height = imgHeight;
        if (Orientation && Orientation != 1) {
          switch(Orientation) {
            case 6:     // 旋转90度
              canvas.width = imgHeight;
              canvas.height = imgWidth;
              ctx.rotate(Math.PI / 2);
              // (0, -imgHeight) 从旋转原理图那里获得的起始点
              ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
              break;
            case 3:     // 旋转180度
              ctx.rotate(Math.PI);
              ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
              break;
            case 8:     // 旋转-90度
              canvas.width = imgHeight;
              canvas.height = imgWidth;
              ctx.rotate(3 * Math.PI / 2);
              ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
              break;
          }
        } else {
          ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
        }

        // 图片压缩后的结果
        let compressDataURL;
        // 临时存储到压缩结果，用来做最优压缩结果处理
        const tempDataURLs = [null, null];

        // 如果指定文件大小大于原文件大小，则不做压缩处理
        if (config.size * 1024 > fileSize) {
          compressDataURL = canvas.toDataURL('image/jpeg', 1);
        }else{
          for (let x = 1; x <= 7; x++) {
            compressDataURL = canvas.toDataURL('image/jpeg', imageQuality);

            // 当前图片尺寸
            let CalculationSize = compressDataURL.length * proportion;

            // 如果到循环第七次还没有达到精确度的值，那说明该图片不能达到到此精确度要求
            // 这时候最后一次循环出来的dataURL可能不是最精确的，需要取其周边两个dataURL三者比较来选出最精确的；
            if (x === 7) {
              if (resultSize.max < CalculationSize || resultSize.min > CalculationSize) {
                compressDataURL = [compressDataURL, tempDataURLs[0], tempDataURLs[1]]
                  .filter(function (i) {
                    return i;
                  }).sort(function (a, b) {
                    return Math.abs(a.length * proportion - resultSize.accurate) - Math.abs(b.length * proportion - resultSize.accurate);
                  })[0];
              }
              break;
            }

            if (resultSize.max < CalculationSize) {
              tempDataURLs[1] = compressDataURL;
              imageQuality -= 0.5 ** (x + 1);
            } else if (resultSize.min > CalculationSize) {
              tempDataURLs[0] = compressDataURL;
              imageQuality += 0.5 ** (x + 1);
            } else {
              break;
            }
          }
        }

        config.success && config.success(compressDataURL);
      }
    }
  }
};

/**
 * 生成随机字符串
 * @param min：最小长度
 * @param max：最大长度
 * @param randomFlag：是否生成在最小和最大长度之间的字符串
 * @returns {string}
 */
export const randomString = function(min = 16, max = 128, randomFlag){
  let str = '', range = min;
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  // 随机产生
  if(randomFlag){
    range = Math.round(Math.random() * (max - min)) + min;
  }

  for(let i = 0; i < range; i++){
    const pos = Math.round(Math.random() * (arr.length - 1));

    str += arr[pos];
  }

  return str;
};

/** 获取文件后缀名 */
export const getSuffix = function(filename) {
  const pos = filename.lastIndexOf('.');
  let suffix = '';

  if (pos !== -1) {
    suffix = filename.substring(pos);
  }

  return suffix;
};



// WEBPACK FOOTER //
// ./src/utils/index.js